import styled from 'styled-components';
export const Iframe = styled.iframe `
    width: ${props => props.width}
    height: ${props => props.height}
`;
//# sourceMappingURL=PdfIframe.Styles.js.map